import { Injectable, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { Observable } from 'rxjs';
import { ApiEndPointsModuleMaster } from '../../common/apiUrls/api-end-points-module-master';

@Injectable({
  providedIn: 'root'
})
export class ModuleMasterService {
  private baseUrl:any;
  constructor(@SkipSelf()private _http: HttpClient, 
  private apiAddress: ApiEndPointsModuleMaster, public env: EnvService,
    private constant: Constants,) { 
if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrl = this.constant.ManageModulePortNumber;
else
     this.baseUrl = this.env.apiUrl+this.constant.ManageModulePortNumber;
    }

   //private baseUrl = this.env.apiUrl;
   
   //private baseUrl = this.constant.ManageModulePortNumber;
  // private baseUrl = this.env.apiUrl+this.constant.ManageModulePortNumber;
   addModule(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addModule;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getModuleList(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getModule;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteModule(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.deleteModule;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateModule(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updateModule;
    return this._http.post(apiURL, reqModel).pipe();
  }

}
